// @ts-nocheck
// Store Custom Widget
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    topBottom = "topBottom",
    sides = "sides",
    centerContent = "centerContent",
    hasMobileDimensions = "hasMobileDimensions",
    mobileTopBottom = "mobileTopBottom",
    mobileSides = "mobileSides",
    backgroundColor = "backgroundColor",
}

interface OwnProps extends WidgetProps {
    extendedStyles?: WrapperStyles;
    fields: {
        [fields.topBottom]: number;
        [fields.sides]: number;
        [fields.centerContent]: boolean;
        [fields.hasMobileDimensions]: boolean;
        [fields.mobileTopBottom]: number;
        [fields.mobileSides]: number;
        [fields.backgroundColor]: string;
    };
}

export interface WrapperStyles {
    spacer?: InjectableCss;
}

export const wrapperStyles: WrapperStyles = {
    spacer: {
        css: css`
            display: block;
            width: 100%;
        `,
    },
};

const styles = wrapperStyles;

const Wrapper: FC<OwnProps> = ({ fields, id }) => {
    const mobileTopBottom = fields.hasMobileDimensions ? fields.mobileTopBottom : fields.topBottom;
    const mobileSides = fields.hasMobileDimensions ? fields.mobileSides : fields.sides;

    const contentAlign = fields.centerContent ? "center" : "left";
    const backgroundColor = fields.backgroundColor ? fields.backgroundColor : "inherit";

    const wrapperStyles = {
        css: css`
            ${styles.spacer?.css || ""}
            text-align: ${contentAlign};
            background-color: ${backgroundColor};
            ${breakpointValues(
                [
                    `${pxToRem(mobileTopBottom)} ${pxToRem(mobileSides)}`,
                    null,
                    null,
                    `${pxToRem(fields.topBottom)} ${pxToRem(fields.sides)}`,
                ],
                "padding",
            )}
        `,
    };

    return (
        <StyledWrapper {...wrapperStyles}>
            <Zone contentId={id} zoneName="Content"></Zone>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: Wrapper,
    definition: {
        group: "Basic",
        displayName: "Wrapper",
        icon: "brackets-square",
        fieldDefinitions: [
            {
                name: fields.topBottom,
                displayName: "Top/Bottom",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                min: 0,
                tooltip: "Size will render in px",
            },
            {
                name: fields.sides,
                displayName: "Sides",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                min: 0,
                tooltip: "Size will render in px",
            },
            {
                name: fields.centerContent,
                displayName: "Center content horizontally",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: true,
                isRequired: true,
                variant: "toggle",
            },
            {
                name: fields.hasMobileDimensions,
                displayName: "Add Mobile Specific Dimensions",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
                isRequired: true,
                variant: "toggle",
            },
            {
                name: fields.mobileTopBottom,
                displayName: "Mobile Top/Bottom",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                min: 0,
                isVisible: item => item?.fields[fields.hasMobileDimensions],
            },
            {
                name: fields.mobileSides,
                displayName: "Mobile Sides",
                editorTemplate: "IntegerField",
                defaultValue: 10,
                fieldType: "General",
                min: 0,
                isVisible: item => item?.fields[fields.hasMobileDimensions],
            },
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
